export const motion = {
  duration: {
    instant: 0,
    fast: 120,
    base: 200,
    slow: 320,
  },
  easing: {
    easeOut: 'cubic-bezier(0.2, 0, 0, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
} as const;
